const overspeedAlarm = {
  licensePlate: "licensePlate",
  AlarmInfo: "Alarm info",
  Type: "Type",
  faultTime: "Fault time",
  startTime: "Alarm-begin time",
  alarmStartSpeed: "Alarm-begin Speed(km/h)",
  alarmEndSpeed: "Alarm-ended Speed(km/h)",
  startLocation: "Alarm-begin location",
  endLocation: "Alarm-ended location",
  endTime: "Alarm-ended time"
} 
export default overspeedAlarm